/** Scoped styles for the TipTap `.tiptap-editor` content area. */
export function EditorStyles() {
    return (
        <style>{`
            .tiptap-editor {
                font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
                font-size: 14px;
                line-height: 1.6;
                color: #212529;
            }

            .tiptap-editor p.is-editor-empty:first-child::before {
                color: #adb5bd;
                content: attr(data-placeholder);
                float: left;
                height: 0;
                pointer-events: none;
            }

            .tiptap-editor a {
                color: #228be6;
                text-decoration: underline;
            }

            .tiptap-editor code {
                background-color: #f1f3f5;
                border-radius: 4px;
                padding: 0.2em 0.4em;
                font-size: 0.9em;
            }

            .tiptap-editor pre {
                background-color: #f8f9fa;
                border-radius: 4px;
                padding: 12px;
                font-family: 'Courier New', monospace;
                overflow-x: auto;
            }

            .tiptap-editor img {
                max-width: 100%;
                height: auto;
                border-radius: 4px;
            }

            .tiptap-editor table {
                border-collapse: collapse;
                width: 100%;
                margin: 16px 0;
            }

            .tiptap-editor table td,
            .tiptap-editor table th {
                border: 1px solid #dee2e6;
                padding: 8px;
                text-align: left;
            }

            .tiptap-editor table th {
                background-color: #f8f9fa;
                font-weight: 600;
            }

            .tiptap-editor .mention {
                display: inline;
                background-color: #e7f5ff;
                color: #1971c2;
                border-radius: 3px;
                padding: 0.05em 0.25em;
                font-weight: 500;
                font-size: 0.9em;
            }

            .tiptap-editor mark {
                border-radius: 2px;
                padding: 0.1em 0.2em;
            }
        `}</style>
    );
}
